export default __webpack_public_path__ + "static/media/Battlebrace.c9ce2895.jpg";